import { productList } from "./product-list";
import { productForm } from "./product-form";
import { importProductsXlsx } from "./import-products-xlsx";
import productsTab from "./products-tab.json";

export const products = {
	productList,
	productForm,
	importProductsXlsx,
	productsTab,
};
